// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1RSKi","toggleWrap":"styles_toggleWrap__2vCV-","content":"styles_content__1uRO_","selectAreaCode":"styles_selectAreaCode__1JF2t"};